import { http } from "../client";
export var logout = function () { return http.api.post("/auth/logout"); };
